import { ApiService } from "../..";

export const getSampleGroupList = () => {
  return ApiService.baseAction("sample-group/list", {}, "get");
};
